import { Alert, Platform } from 'react-native';
import * as Linking from 'expo-linking';
import Constants from 'expo-constants';
import * as Application from 'expo-application';

export const SUPPORT_EMAIL = 'support@tripvio.app' as const;

export type SupportMailKind = 'bug' | 'feedback' | 'feature';

/** Same pre-filled body for bug / feedback / feature so users see one consistent template; only the subject line changes. */
function buildSupportBody(): string {
  const version =
    Platform.OS === 'web'
      ? String(Constants.expoConfig?.version ?? 'unknown')
      : String(Application.nativeApplicationVersion ?? Constants.expoConfig?.version ?? 'unknown');
  const build = Platform.OS === 'web' ? 'n/a' : String(Application.nativeBuildVersion ?? 'n/a');

  return [
    '',
    '(Describe what happened, steps to reproduce, or your idea)',
    '',
    '---',
    'Device info (helps us debug):',
    `Platform: ${Platform.OS}`,
    `App version: ${version}`,
    `Build: ${build}`,
    '',
  ].join('\n');
}

function subjectForKind(kind: SupportMailKind): string {
  switch (kind) {
    case 'bug':
      return '[Tripvio] Bug report';
    case 'feedback':
      return '[Tripvio] Feedback';
    case 'feature':
      return '[Tripvio] Feature request';
    default:
      return '[Tripvio] Support';
  }
}

/** Opens the default mail composer to support@tripvio.app with a helpful subject line and diagnostics. */
export async function openSupportMailbox(kind: SupportMailKind): Promise<void> {
  const subject = subjectForKind(kind);
  const body = buildSupportBody();
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  try {
    const canOpen = await Linking.canOpenURL(mailto);
    if (!canOpen) {
      Alert.alert('Email support', `Unable to open your email app. Please write to:\n${SUPPORT_EMAIL}`);
      return;
    }
    await Linking.openURL(mailto);
  } catch (e) {
    console.warn('[supportContact] mailto failed', e);
    Alert.alert('Email support', `Unable to open your email app. Please write to:\n${SUPPORT_EMAIL}`);
  }
}
